export default __webpack_public_path__ + "static/media/work-1left-2.b20a1c6a.png";